export default __webpack_public_path__ + "static/media/silver-cup-icon.20ce50da.svg";